import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import DataConfig from "./_config.json";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Inventory from "./PSInventory/Inventory";
import CSSavecustomer from "./PSSavecustomer/Savecustomer";
//report

import PDIReport from "./PSReport/PSPDIReport/mainreport";
import YamahaReport from "./PSReport/PSYamahaReport/mainReport";
import PSORDERPR from "./PSORDERPR/Main";
import PSPURCHASE from "./PSPURCHASE/Main";
/* ใบวางบิล */
import PSPaybill from "./PSPaybill/Main";
/* ปิดใบสั่งขาย */
import PSCCSaleOrder from "./PSCC_SaleOrder/Main";
/* บันทึกฝากเงินสด */
import PSCsbankcashin from "./PSCsbankcashin/Main";
/* หน้าขาย */
import PSquot from "./PSquot/Main.js";
import PSSaleAndService from "./PSSaleAndService/Main";
// import PSReservationOrder from './PSReservationOrder/Main';
import PSSalesOrder from "./PSSalesOrder/Main";
import PSReturnProduct from "./PSReturnProduct/Main";
import PSSaleRet from "./PSSaleRet/Main";
/*เจ้าหนี้ */
import PSApotherdebt from "./PSApotherdebt/Main";
import PSPAYMENT from "./PSPAYMENT/Main";
/* โอนสินค้า */
import PSSaveAskTransfer from "./PSTransferProduct/PSSaveAskTransfer/Main";
import PSSaveTransfer from "./PSTransferProduct/PSSaveTransfer/Main";
//** บันทึกค่าใฃ้จ่ายและรายได้อื่นๆ*/
import PSExpenses from "./PSExpensesAndBad/PSExpenses/Main";
import PSOtherBad from "./PSExpensesAndBad/PSOtherBad/Main";
import Savecreditor from "./PSSavecreditor/Savecreditor";

import PSARDeposit from "./PSARDeposit/Main";
import PSARCNDeposit from "./PSARCNDeposit/Main";
import PSReceipt from "./PSReceipt/Main";
import PSMPSummit from "./PSMPSummit/PSMPSummit";
import PSOrder from "./PSOrder/Main";
import PSOrderBook from "./PSOrderBook/index";
import CSWithdrawalrequest from "./PSWithdrawalrequest/Withdrawalrequest";
import CSProductbring from "./PSProductbring/Productbring";
import { PSToHonda, PSFG, PSSTKJOBORDER } from "./Pages/index";
import Mainreport from "./PSReport/mainreport";
import styles from "./assets/jss/psstyle/component/headerStyle";

import Login from "./login";
import Home from "./home";
import Admin from "./View/admin/main/index";

import { Routes, Route, Link, Navigate } from "react-router-dom";
import Hidden from "@mui/material/Hidden";
import { drawerWidth, appbarHeight } from "./assets/jss/psstyle/psacount";
import AccountMenu from "./Components/Navbars/Acountmenu";
import parseJwt from "./CustomFunction/parseJWT.js";
import Logout from "./CustomFunction/User/logout";
import { genpostURLTEST, genURL } from "./_getjson";
import axios from "axios";
import RichObjectTreeView from "./Components/Slidebar/RichObjectTreeView";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    width: `calc(100% - ${drawerWidth}px)`,
    height: "100vh",
    overflowY: "auto",
  })
);
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  height: appbarHeight,
  ...styles.appBar,
  display: "flex",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: appbarHeight,
  ...styles.DrawerHeader,
}));

if (
  localStorage.getItem("Token") !== null &&
  window.location.pathname === "/login"
) {
  window.location.href = "/home";
} else if (
  localStorage.getItem("Token") === null &&
  window.location.pathname !== "/login"
) {
  window.location.href = "/login";
} else if (
  localStorage.getItem("Token") !== null &&
  window.location.pathname === "/logout"
) {
  Logout();
  window.location.href = "/login";
}

if (localStorage.getItem("Token") !== null) {
  let urlCheckpermision =
    "CSRIGHT/Checkpermision?usercode=" + localStorage.getItem("Username");
  console.log("urlCheckpermision", genURL(urlCheckpermision));
  axios.get(genURL(urlCheckpermision), { timeout: 3600 }).then((res) => {
    localStorage.setItem("checkoftxt", JSON.stringify(res.data[0]));
    localStorage.setItem("Editamountpermision", res.data[0].AMOUNT);
    localStorage.setItem("Permissiongroup", res.data[0].CODE);
  });
}

let RouterPath = (
  <>
    <Route index path="/home" element={<Home />} />
    <Route path="/login" element={<Login />} />
    <Route path="/Inventory" element={<Inventory />} />
    <Route path="/Savecreditor" element={<Savecreditor />} />
    <Route path="/Savecustomer" element={<CSSavecustomer />} />
    <Route path="/PSORDERPR" element={<PSORDERPR />} />
    <Route path="/PSPURCHASE" element={<PSPURCHASE />} />
    <Route path="/PSARDeposit" element={<PSARDeposit />} />
    <Route path="/PSARCNDeposit" element={<PSARCNDeposit />} />
    <Route path="/PSReceipt" element={<PSReceipt />} />
    <Route path="/PSPaybill" element={<PSPaybill />} />
    <Route path="/PSCsbankcashin" element={<PSCsbankcashin />} />
    <Route path="/PSCC_SaleOrder" element={<PSCCSaleOrder />} />
    <Route path="/PSOrder" element={<PSOrder />} />
    <Route path="/PSMPSummit" element={<PSMPSummit />} />
    <Route path="/PSquot" element={<PSquot />} />
    <Route path="/PSSaleAndService" element={<PSSaleAndService />} />
    <Route path="/PSSalesOrder" element={<PSSalesOrder />} />
    <Route path="/PSReturnProduct" element={<PSReturnProduct />} />
    <Route path="/PSSaleRet" element={<PSSaleRet />} />
    <Route path="/PSApotherdebt" element={<PSApotherdebt />} />
    <Route path="/PSPAYMENT" element={<PSPAYMENT />} />
    <Route path="/PSSaveAskTransfer" element={<PSSaveAskTransfer />} />
    <Route path="/PSSaveTransfer" element={<PSSaveTransfer />} />
    <Route path="/PSExpenses" element={<PSExpenses />} />
    <Route path="/PSOtherBad" element={<PSOtherBad />} />
    <Route path="/PSOrderBook" element={<PSOrderBook />} />
    <Route path="/CSWithdrawalrequest" element={<CSWithdrawalrequest />} />
    <Route path="/CSProductbring" element={<CSProductbring />} />
    <Route path="/PDIReport" element={<PDIReport />} />
    <Route path="/YamahaReport" element={<YamahaReport />} />
    <Route path="/manage" element={<Admin />} />
    <Route path="/report/:id" element={<Mainreport />} />
    <Route path="/PSToHonda" element={<PSToHonda />} />
    <Route path="/PSFG" element={<PSFG />} />
    <Route path="/PSSTKJOBORDER" element={<PSSTKJOBORDER />} />
    <Route path="*" element={<NoMatch />} />
  </>
);

async function NoMatch() {
  // console.log("localStoragegetItemToken", localStorage.getItem('Token'))
  if (localStorage.getItem("Token")) {
    let datenow = Math.round(new Date().getTime() / 1000);
    let dateExp = parseJwt(localStorage.getItem("Token")).exp;
    // console.log("localStoragegetItemToken ", dateExp);
    //  console.log("localStoragegetItemToken datenow", datenow);
    if (datenow > dateExp) {
      Logout();
      // window.location.href = '/login'
    } else {
      window.location.href = "/home";
    }
  } else {
    //   console.log("else");
    Logout();
    // window.location.href = '/login'
  }
}

export default function PersistentDrawerLeft() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [openToggle, setOpenToggle] = React.useState(false);
  const [categoryReport, setCategoryReport] = React.useState([]);
  const [menuData, setMenuData] = React.useState([]);

  React.useEffect(() => {
    if (localStorage.getItem("Token")) {
      checkOpenToggle();
    }
    // get data for report menu
    fetchMenu();
    fetchCategory();
    // eslint-disable-next-line
  }, []);

  const checkOpenToggle = () => {
    if (localStorage.getItem("OpenToggle") === "false") {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const toggleDrawer = (open) => (event) => {
    setOpen(open);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
    localStorage.setItem("OpenToggle", "true");
  };
  const handleDrawerClose = () => {
    setOpen(false);
    localStorage.setItem("OpenToggle", "false");
  };
  const handleDrawerToggle = () => {
    setOpenToggle((prev) => !prev);
  };

  const fetchMenu = async () => {
    try {
      const url = "CSRIGHT/GetMenu?user=" + localStorage.getItem("Username");
      const response = await axios.get(genURL(url));
      setMenuData(response.data);
    } catch (error) {
      console.error("fetchMenu error:", error);
    }
  };

  const fetchCategory = async () => {
    console.log("fetchCategory called - starting API call");
    try {
      const url = "reportmanage/category?";
      console.log("fetchCategory URL:", genURL(url));
      const response = await axios.get(genURL(url));
      console.log("fetchCategory API response:", response);
      console.log("fetchCategory API response data:", response.data);
      console.log(
        "fetchCategory API response data type:",
        typeof response.data
      );
      console.log(
        "fetchCategory API response data isArray:",
        Array.isArray(response.data)
      );

      const elementCategory = response.data.filter(
        (item) => item.catelevel === 0
      );
      console.log("fetchCategory filtered elementCategory:", elementCategory);
      console.log(
        "fetchCategory filtered elementCategory length:",
        elementCategory.length
      );

      setCategoryReport(elementCategory);
      console.log(
        "fetchCategory - setCategoryReport called with:",
        elementCategory
      );
    } catch (error) {
      console.error("reportmanage error:", error);
      console.error("reportmanage error message:", error.message);
      console.error("reportmanage error response:", error.response);
    }
  };
  return (
    <>
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <CssBaseline />
        <AppBar position="static" open={open}>
          <Toolbar>
            {localStorage.getItem("Token") !== null ? (
              <>
                <Box component="div" sx={{ flexGrow: 1 }}>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{ mr: 2, ...(open && { display: "none" }) }}
                  >
                    <MenuIcon />
                  </IconButton>
                </Box>
                <Box>
                  <Hidden mdDown implementation="css">
                    <AccountMenu categoryReport={categoryReport} />
                  </Hidden>
                  <Hidden mdUp implementation="css">
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Hidden>
                </Box>
              </>
            ) : null}
          </Toolbar>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              overflowY: "hidden",
              overflowX: "hidden",
              display: "flex",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          {/* มีผลต่อความเร็ว */}
          {/* <Slidebar /> */}
          <RichObjectTreeView data={Array.isArray(menuData) ? menuData : []} />
        </Drawer>
        {/* end Drawer left */}
        <Main open={open}>
          <DrawerHeader />
          <Routes>{RouterPath}</Routes>
        </Main>
      </Box>
      <div>
        <React.Fragment key={"top"}>
          <SwipeableDrawer
            anchor={"top"}
            open={openToggle}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
          >
            <Box sx={{ ...styles.SwipeableDrawer }}>
              <AccountMenu categoryReport={categoryReport} />
            </Box>
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
}
